// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerCarousel_container__2gVUq"};